import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";
import { format } from "date-fns";

import Container from "../../components/Container";
import Text from "../../components/Text";
import Heading from "../../components/Heading";
import Button from "../../components/Button";
import StickyFooter from "../../components/StickyFooter";
import { colors, fonts } from "../../theme";

const styles = StyleSheet.create({
  container: { backgroundColor: colors.black, flex: 1 },
  scrollView: { padding: 20 },
  checkCircle: {
    width: 56,
    height: 56,
    borderRadius: 28,
    borderWidth: 1,
    borderColor: colors.green,
    backgroundColor: "rgba(95, 182, 168, 0.14)",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 12,
    marginBottom: 18,
  },
  checkMark: { color: colors.green, fontSize: 26, fontFamily: fonts.bold },
  title: { color: colors.white, textAlign: "center", marginBottom: 6 },
  subtitle: { color: colors.midGrey, textAlign: "center", marginBottom: 20 },
  summaryCard: {
    backgroundColor: "#262b42",
    borderWidth: 1.5,
    borderColor: "#2a2d3f",
    borderRadius: 14,
    padding: 14,
    marginBottom: 20,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 7,
  },
  summaryRow__divider: {
    borderTopWidth: 1,
    borderTopColor: "#2a2d3f",
  },
  summaryKey: { color: "#6b6f82", fontSize: 12 },
  summaryValue: { color: colors.white, fontFamily: fonts.semiBold, fontSize: 12 },
  idNotice: {
    borderWidth: 1,
    borderColor: "rgba(254, 185, 76, 0.35)",
    backgroundColor: "rgba(254, 185, 76, 0.08)",
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  idNoticeTitle: { color: colors.white, fontFamily: fonts.semiBold, marginBottom: 4 },
  idNoticeBody: { color: colors.midGrey },
});

type Props = { navigation: any };

const BookingConfirmationScreen: React.FC<Props> = ({ navigation }) => {
  const { params } = useRoute<any>();
  const { store, service, startsAt, customerFirstName } = params || {};

  return (
    <SafeAreaView style={styles.container} edges={["right", "bottom", "left"]}>
      <Container>
        <ScrollView style={styles.scrollView}>
          <View style={styles.checkCircle}>
            <Text style={styles.checkMark}>{"✓"}</Text>
          </View>
          <Heading size="l" style={styles.title}>
            {customerFirstName ? `You're booked, ${customerFirstName}` : "You're booked"}
          </Heading>
          <Text style={styles.subtitle}>
            A confirmation was sent by text and email.
          </Text>

          <View style={styles.summaryCard}>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryKey}>Service</Text>
              <Text style={styles.summaryValue}>{service?.name}</Text>
            </View>
            <View style={[styles.summaryRow, styles.summaryRow__divider]}>
              <Text style={styles.summaryKey}>When</Text>
              <Text style={styles.summaryValue}>
                {startsAt ? format(new Date(startsAt), "EEE, MMM d 'at' h:mm a") : ""}
              </Text>
            </View>
            <View style={[styles.summaryRow, styles.summaryRow__divider]}>
              <Text style={styles.summaryKey}>Where</Text>
              <Text style={styles.summaryValue}>{store?.name}</Text>
            </View>
          </View>

          <View style={styles.idNotice}>
            <Text style={styles.idNoticeTitle}>Your consent form comes later</Text>
            <Text style={styles.idNoticeBody}>
              We'll text and email you a link to fill it out about an hour
              before your appointment, so your answers are fresh.
            </Text>
          </View>

          <View style={styles.idNotice}>
            <Text style={styles.idNoticeTitle}>Bring a valid photo ID</Text>
            <Text style={styles.idNoticeBody}>
              No need to upload it -- our staff will check it in person when
              you arrive.
            </Text>
          </View>
        </ScrollView>
      </Container>
      <StickyFooter>
        <Button
          title="Done"
          onPress={() =>
            navigation.dangerouslyGetParent?.()?.navigate("Main")
          }
        />
      </StickyFooter>
    </SafeAreaView>
  );
};

export default BookingConfirmationScreen;
